import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { useStyledBlock, StyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type IconListProps = { items: string[] };

export function IconListBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<IconListProps>();
  const items = props.items ?? [];

  if (tab === "content") {
    return (
      <div className="space-y-2">
        {items.map((item, i) => (
          <div key={i} className="flex gap-1">
            <Input
              className="h-8 flex-1 text-xs"
              value={item}
              onChange={(e) =>
                setProp((p) => {
                  const next = [...(p.items ?? [])];
                  next[i] = e.target.value;
                  p.items = next;
                })
              }
            />
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8 shrink-0"
              onClick={() =>
                setProp((p) => {
                  p.items = (p.items ?? []).filter((_, j) => j !== i);
                })
              }
            >
              <Trash2 className="h-3 w-3" />
            </Button>
          </div>
        ))}
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-7 text-xs"
          onClick={() => setProp((p) => { p.items = [...(p.items ?? []), "New item"]; })}
        >
          <Plus className="mr-1 h-3 w-3" />
          Add item
        </Button>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showTypography />;
  }
  return null;
}
